import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import { get } from "../../api";

const { SITEMAP } = Routes;


/*******************
@purpose :  get card detail data
@Parameter : {}
@Author : INIC
******************/

export const getSitemap = () => async (dispatch) => {
  try {
    let res = await get(SITEMAP, true);
    dispatch({ type: types.SET_SITEMAP_DETAIL, data: res.data });
    return Promise.resolve(res.data);
  } catch (error) {
    return Promise.reject(error);
  }
};

